import styled from 'styled-components';
import { Divider as SemanticDivider } from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: white;
  padding: 10px;
  flex-direction: column;
  border-radius: 4px;
  max-width: 300px;
  width: 100%;
  height: fit-content;
  @media only screen and (min-device-width : 1367px) {
    padding: 30px;
    max-width: 350px;
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const ContainerResult = styled.div`
  display: flex;
  margin: 10px;
  align-items: flex-end;
`;

export const Box = styled.div`
  height: 25px;
  width: 25px;
  border-radius: 4px;
  margin-right: 10px;
  background: ${({ multicolor, color }) => (multicolor ? `
    linear-gradient(90deg, ${multicolor[0]} 50%, ${multicolor[1]} 50%)`
  : color)};
`;

export const Divider = styled(SemanticDivider)`
  && {
    margin: 0 0 0 45px;
  }
`;

export const Text = styled(TextLayoutComponent)``;
